<script>
  import { format } from 'svelte-i18n';

  import { Chart } from '@client/components/charts';

  export let data = {};
  export let label = null;
  export let title = null;
  export let subtitle = null;
  export let height = '90px';
  export let width = '100%';

  let tooltip = $format('label.TOOLTIP.ATTACHMENT_SUMMARY');

  let options = {
    responsive: true,
    plugins: {
      legend: false
    },
    scales: {
      x: {
        type: 'time',
        position: 'bottom',
        time: {
          parser: 'yyyy-MM-dd',
          displayFormats: {
            day: 'M/d',
            month: 'MMM yy'
          },
          tooltipFormat: 'MMM d, yyyy',
          unit: 'day'
        },
        grid: {
          display: false
        },
        ticks: {
          maxRotation: 0,
          stepSize: 1
        }
      },
      y: {
        grid: {
          display: false
        },
        ticks: {
          display: false
        }
      }
    }
  };
</script>

<Chart type="line" bind:data bind:options bind:label bind:title bind:subtitle bind:height bind:width bind:tooltip />
